import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './SiteHeader.css';

// The public site header: black bar, SolushipX logo, homepage sections,
// Pricing and Track, then Log in / Start shipping (or Dashboard when signed in).
// Used by the homepage (transparent, over its hero), the public pages via
// AppLayout, and the public tracking page.

const SECTIONS = [
    { label: 'Platform', id: 'platform' },
    { label: 'Carriers', id: 'carriers' },
    { label: 'AI', id: 'ai' },
    { label: 'Developers', id: 'developers' }
];

const SiteHeader = ({ transparent = false }) => {
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();
    const { currentUser } = useAuth();
    const onHome = pathname === '/';
    const close = () => setOpen(false);

    // On the homepage the sections are in-page anchors; elsewhere they lead back to it.
    const section = (s, onClick) => (onHome
        ? <a key={s.id} href={`#${s.id}`} onClick={onClick}>{s.label}</a>
        : <Link key={s.id} to={`/#${s.id}`} onClick={onClick}>{s.label}</Link>);

    return (
        <header className={`sh${transparent ? ' sh-transparent' : ''}`}>
            <div className="sh-inner">
                <Link to="/" className="sh-logo" aria-label="SolushipX home">
                    <img src="/images/solushipx_logo_white.png" alt="SolushipX" />
                </Link>
                <nav className="sh-links" aria-label="Main">
                    {SECTIONS.map((s) => section(s))}
                    <Link to="/pricing">Pricing</Link>
                    <Link to="/tracking">Track</Link>
                </nav>
                <div className="sh-right">
                    {currentUser ? (
                        <Link to="/admin" className="sh-btn">Dashboard</Link>
                    ) : (
                        <>
                            <Link to="/login" className="sh-login">Log in</Link>
                            <Link to="/signup" className="sh-btn">Start shipping</Link>
                        </>
                    )}
                    <button
                        type="button"
                        className="sh-menu-btn"
                        aria-label={open ? 'Close menu' : 'Open menu'}
                        aria-expanded={open}
                        aria-controls="sh-menu"
                        onClick={() => setOpen((o) => !o)}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
                        </svg>
                    </button>
                </div>
            </div>
            <div id="sh-menu" className={`sh-menu${open ? ' open' : ''}`}>
                {SECTIONS.map((s) => section(s, close))}
                <Link to="/pricing" onClick={close}>Pricing</Link>
                <Link to="/tracking" onClick={close}>Track a shipment</Link>
                {currentUser
                    ? <Link to="/admin" onClick={close}>Dashboard</Link>
                    : <Link to="/signup" onClick={close}>Start shipping</Link>}
            </div>
        </header>
    );
};

export default SiteHeader;
